'use strict';

/* $ */
/* global _ */
/* global Backbone */
/* Marionette */

import { CalculatorBaseView } from './core/base';

import { CalculatorParamCollection,
         CalculatorParamModel,
         CalculatorParamModelCollection,
         CalculatorImageParamCollection } from './core/param';

import { CalculatorInfo } from './core/info';
import { CalculatorBuy } from './core/buy';

import { CountInput } from '../common/count_input';

let basketRadio = Backbone.Radio.channel('basket');

/**
 * Модель для хранения модели данных бруска
 */
class CalculatorBarModel extends Backbone.Model {
    default(){
        return {
            bar_volume: 0,
            volume: 0,
            price: 0,
            summ: 0,
            count: 0,
            can_add_to_basket: false
        };
    }
    initialize(){
        let self = this;

        this.set('count', parseFloat(this.get('default_count')));
        this.set('can_add_to_basket', this.get('count') > 0);

        self.listenTo(basketRadio, 'calculator:in:basket', self.checkCalculatorIsAdded);

        self.listenTo(self, 'change:bar_length change:bar_width change:bar_height', self.calculateBarPrice);

        self.listenTo(self, 'change:count change:bar_volume', self.calculateVolume);
        self.listenTo(self, 'change:count change:price', self.calculateSumm);
        self.listenTo(self, 'change:count change:price_id', self.checkCanAddToBasket);

        self.processData();
    }
    // Приведем все числа к дробным, чтобы не запутаться в расчетах
    processData() {
        let self = this;
        let dict = self.get('dict');
        let data = self.get('data');

        _.each(data, function(item){
            _.each(dict, function(elem){
                item[elem] = parseFloat(item[elem]);
            });
        });

        self.set('data', data, { silent: true });
    }
    calculateBarPrice(){
        let self = this;

        let bar_length = self.get('bar_length');
        let bar_width = self.get('bar_width');
        let bar_height = self.get('bar_height');
        let data = self.get('data');

        let price_item = _.find(data, function(item){
            return ((item.width == bar_width) && (item.height == bar_height)) ? true : false;
        });

        let price_id = 0;
        let price = 0;
        if(!_.isUndefined(price_item)){
            price = price_item.price;
            price_id = price_item.n;
        }

        // console.log(bar_width, bar_height, bar_length);
        // Переведем мм3 в м3
        let volume = (bar_width / 1000) * (bar_height / 1000) * (bar_length / 1000);
        // console.log('bar_volume', volume);
        volume = Math.floor(volume * 10000) / 10000; // округлим, чтобы подровнять округление js
        self.set('bar_volume', volume);

        self.set('price_id', price_id);
        self.set('price', price * bar_length / 1000);
    }
    calculateVolume(){
        let self = this;

        self.set('volume', self.get('count') * self.get('bar_volume'));
    }
    calculateSumm(){
        let self = this;

        self.set('summ', self.get('count') * self.get('price'));
    }
    addToBasket() {
        let self = this;
        self.set('is_progress', true);
        basketRadio.trigger('calculator:to:basket', self);
    }
    checkCalculatorIsAdded(calculator) {
        let self = this;

        if(self.get('calculator_id') == calculator.calculator_id){
            self.set({
                count: this.get('default_count'),
                name: calculator.name,
                is_progress: false
            });

            self.trigger('on:value:changed', 'count');
            self.trigger('calculator:added:to:basket');
        }
    }
    checkCanAddToBasket() {
        let self = this;
        if((self.get('price_id') > 0) && (self.get('count') > 0)) {
            self.set('can_add_to_basket', true);
        }else{
            self.set('can_add_to_basket', false);
        }
    }
}

/**
 * Контроллер для калькулятора бруска
 */
class CalculatorBar extends CalculatorBaseView {
    getTemplate(){
        return '#tpl-calculator__bar';
    }
    ui(){
        let ui = super.ui();
        return _.extend(ui, {
            'infoVolume': '.js-calculator__info-volume',
            'infoPrice': '.js-calculator__info-price',
            'infoCount': '.js-calculator__info-count',
            'summaryVolume': '.js-calculator__summary-volume',
            'summarySumm': '.js-calculator__summary-summ',
        });
    }
    regions() {
        let regions = super.regions();
        return _.extend(regions, {
            'infoVolume': '@ui.infoVolume',
            'infoPrice': '@ui.infoPrice',
            'infoCount': '@ui.infoCount',
            'summaryVolume': '@ui.summaryVolume',
            'summarySumm': '@ui.summarySumm',
        });
    }
    onRender(){
        let self = this;

        self.$el.addClass('m--'+self.model.get('type'));

        // Отрисуем параметры
        let input_params = self.getOption('input_params');
        self.params_collection = new CalculatorParamModelCollection();
        var i = 0;
        while(i < input_params.length){
            let param_item = new CalculatorParamModel(input_params[i]);
            self.params_collection.add(param_item);
            i++;
        }
        self.showChildView('params', new CalculatorParamCollection({ collection: self.params_collection }));
        self.showChildView('image', new CalculatorImageParamCollection({ model: self.model,
                                                                         collection: self.params_collection }));

        // Отрисуем информационные параметры

        new CalculatorInfo({
            el: self.getUI('infoVolume'),
            model: self.model,
            field_publ_name: 'Объем 1 единицы',
            field: 'bar_volume',
            unit: 'м<sup>3</sup>',
            value_as: 'approx' });

        new CalculatorInfo({
            el: self.getUI('infoPrice'),
            model: self.model,
            field_publ_name: 'Цена 1 единицы',
            field: 'price',
            value_as: 'price' });

        self.showChildView('infoCount', new CountInput({ model: self.model,
                                                         field: 'count',
                                                         type: 'int',
                                                         show_type: 'number_int' }));

        new CalculatorInfo({
            el: self.getUI('summaryVolume'),
            model: self.model,
            field_publ_name: 'Общий объем',
            field: 'volume',
            unit: 'м<sup>3</sup>',
            value_as: 'approx' });

        new CalculatorInfo({
            el: self.getUI('summarySumm'),
            model: self.model,
            field_publ_name: 'Стоимость',
            field: 'summ',
            value_as: 'price' });

        self.showChildView('buy', new CalculatorBuy({ model: self.model }));

        self.paramsCollectionChanged();
    }
    paramsCollectionChanged(){
        let self = this;
        let params = self.params_collection.getParams();

        self.model.set({
            'bar_width': params['width'],
            'bar_height': params['height'],
            'bar_length': params['length']
        });
    }
}

export {
    CalculatorBarModel,
    CalculatorBar
};

